module.exports = __webpack_public_path__ + "img/icon_form_checkbox.362051b6.svg";